import { useUser } from "../contexts/UserContext";
import { USER_TYPES } from "../types/userType";

const useIsInspection = () => {
  const { userType } = useUser();

  if (!userType) return false;
  if (Array.isArray(userType)) {
    return userType.includes(USER_TYPES.INSPECTION);
  }
  return userType === USER_TYPES.INSPECTION;
};

export default useIsInspection;

